import axios from 'axios'
import { useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import Cookies from 'js-cookie'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

export default function ChangePassword() {
  // const { user } = useAuth()
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
  })
  const [showOldPassword, setShowOldPassword] = useState(false)

  const [showNewPassword, setShowNewPassword] = useState(false)
  const [newPasswordMessage, setNewPasswordMessage] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const user = Cookies.get('user')
      console.log('Token : ', user)
      const parsedToken = JSON.parse(user)
      const token = parsedToken.token
      console.log('formData', formData)
      const response = await axios.post(
        BASE_URL+'/change-password',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      console.log(response.data.message)
      toast.success(response.data.message)
      setNewPasswordMessage(formData.new_password)
      setShowOldPassword(false)
      setShowNewPassword(false)
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }
  const oldPasswordVisible = () => {
    setShowOldPassword(!showOldPassword)
  }
  const newPasswordVisible = () => {
    setShowNewPassword(!showNewPassword)
  }
  const handleRefresh = () => {
    setNewPasswordMessage(!newPasswordMessage)
    window.location.reload()
  }
  return (
    <>
      <style>
        {`
      @media(max-width:768px){
      .large-container{
          margin-top:5rem !important;

      }
      .large-container h3{
          font-size:20px !important;
      }
      .large-container p{
          font-size:12px !important;
      }
      .form-button{
          font-size:12px !important;
      }
      }
  `}
      </style>
      <div className="container-fluid d-flex justify-content-center mt-5 large-container">
        <Card style={{ width: '100%', maxWidth: '700px' }}>
          <div className="bg-light px-4 py-3 d-flex align-items-center justify-content-between">
            <div className="flex-grow-1 text-center position-relative">
              <h3 className="mb-0 text-primary">Change Password?</h3>
            </div>
            <p
              type="button"
              onClick={handleRefresh}
              className="text-danger fw-bold mb-0"
              title="Refresh"
              style={{ cursor: 'pointer' }}
            >
              X
            </p>
          </div>

          <Card.Body className="p-4">
            <p
              className="fw-semibold text-success"
              style={{ letterSpacing: '1px' }}
            >
              Please create a new password
            </p>

            <form onSubmit={handleSubmit} className="form-class">
              <Form.Group className="mb-3 position-relative">
                <Form.Control
                  placeholder="Enter old password"
                  name="old_password"
                  onChange={handleChange}
                  value={formData.old_password}
                  type={showOldPassword ? 'text' : 'password'}
                  required
                />
                <Button
                  variant="link-dark"
                  className="position-absolute end-0 top-50 translate-middle-y me-0 border"
                  style={{ border: 'none' }}
                  onClick={oldPasswordVisible}
                >
                  {showOldPassword ? (
                    <FaEyeSlash size={20} title="Hide" />
                  ) : (
                    <FaEye size={20} title="Show" />
                  )}
                </Button>
              </Form.Group>

              <Form.Group className="mb-3 position-relative">
                <Form.Control
                  placeholder="Enter new password"
                  name="new_password"
                  onChange={handleChange}
                  value={formData.new_password}
                  type={showNewPassword ? 'text' : 'password'}
                  required
                />

                <Button
                  variant="link-dark"
                  className="position-absolute end-0 top-50 border translate-middle-y me-0"
                  style={{ border: 'none' }}
                  onClick={newPasswordVisible}
                >
                  {showNewPassword ? (
                    <FaEyeSlash fontSize={20} title="Hide" />
                  ) : (
                    <FaEye fontSize={20} title="Show" />
                  )}
                </Button>
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100 fw-bold mt-3 form-button"
                style={{ letterSpacing: '2px' }}
              >
                Change password
              </Button>
            </form>
            {newPasswordMessage && (
              <p className="alert alert-success text-center fw-semibold mt-5 ">
                Your new password is
                <span style={{ letterSpacing: '1px', color: 'green' }}>
                  {' '}
                  "{newPasswordMessage}"
                </span>
                . Please note it before exit.
              </p>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  )
}
